import axios from '@/libs/api.request'
import fileAxios from '@/libs/file.request'
// 订单列表
export const apiOrderinfoList = data => {
  return axios.request({
    url: '/orderinfo/list',
    method: 'post',
    data
  })
}
// 订单详情
export const apiOrderinfoInfo = data => {
  return axios.request({
    url: `/orderinfo/info`,
    method: 'post',
    data
  })
}
// 删除订单详情
export const apiOrderDelete = data => {
  return axios.request({
    url: `/orderinfo/delete`,
    method: 'post',
    data
  })
}
export const apiMarkNotNew = data => {
  return axios.request({
    url: `/orderinfo/mark-not-new`,
    method: 'post',
    data
  })
}
// 发货
export const apiOrderinfoSendOut = data => {
  return axios.request({
    url: '/orderinfo/send-out',
    method: 'post',
    data
  })
}

// 快递配送信息
export const apiDeliveryInfo = data => {
  return axios.request({
    url: '/express/delivery-info',
    method: 'post',
    data
  })
}

// 标记为已送达
export const apiArriveOrder = data => {
  return axios.request({
    url: '/orderinfo/arrive',
    method: 'post',
    data
  })
}
// 退单
export const apiRefundOrder = data => {
  return axios.request({
    url: '/orderinfo/refund-order',
    method: 'post',
    data
  })
}
// 打单详情
export const apiOrderinfoInfoList = data => {
  return axios.request({
    url: `/orderinfo/info-list`,
    method: 'post',
    data
  })
}
// 打单设置
export const apiPrintOrderConf = data => {
  return axios.request({
    url: `/orderinfo/print-order-conf`,
    method: 'get',
    data
  })
}

// 修改价格
export const apiChangeDetailPrice = data => {
  return axios.request({
    url: `/orderinfo/change-detail-price`,
    method: 'post',
    data
  })
}
/**
 * 订单改价
 */
export const apiChangePrice = data => {
  return axios.request({
    url: `/orderinfo/change-price`,
    method: 'post',
    data
  })
}
/**
 * 修改备注
 */
export const apiChangeComment = data => {
  return axios.request({
    url: `/orderinfo/change-comment`,
    method: 'post',
    data
  })
}
/**
 * 订单退款
 */
export const apiRefundAmount = data => {
  return axios.request({
    url: `/orderinfo/refund-amount`,
    method: 'post',
    data
  })
}
// 确认价格
export const apiEnsurePrice = data => {
  return axios.request({
    url: `/orderinfo/ensure-price`,
    method: 'post',
    data
  })
}
// 制作产品
export const apiOrderinfoSendMake = data => {
  return axios.request({
    url: `/orderinfo/send-make`,
    method: 'post',
    data
  })
}
// 提交设计图
export const apiOrderinfoSubmitDesign = data => {
  return axios.request({
    url: `/orderinfo/submit-design`,
    method: 'post',
    data
  })
}

// 订单待处理数量
export const apiPrintOrderOperNum = data => {
  return axios.request({
    url: `/orderinfo/oper-num`,
    method: 'post',
    data
  })
}

// 订单导出
export const apiOrderinfoExport = data => {
  return fileAxios.request({
    url: '/orderinfo/export',
    method: 'get',
    data
  }, { responseType: 'blob' })
}
